import { AnyAction } from 'redux';
import { CoachingSessionActionTypes } from '../actions/coachingSessions';
import { ICoachingSessionFullDTO } from '../../pages/Coaching/CoachingSessionFullDTO';
import { CoachingSessionStatus } from '../../pages/Coaching/coaching.enum';
import { getHoursLeftForTheDay } from '../../utils/basic.utils';

const initialState = {
  data: [] as ICoachingSessionFullDTO[]
};

export function CoachingSessionsReducer(state = initialState, action: AnyAction) {
  if (!state) {
    return initialState;
  }

  switch (action.type) {
    case CoachingSessionActionTypes.FETCH:
      const sessions = action.payload;

      const foundUpcomingSession = sessions
        .filter(
          (s) =>
            s.status === CoachingSessionStatus.Confirmed &&
            new Date(s.date).getTime() + getHoursLeftForTheDay() * 60 * 60 * 1000 >= new Date().getTime()
        )
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

      if (foundUpcomingSession.length) {
        foundUpcomingSession[0].isUpcoming = true;
      }

      return {
        ...state,
        data: sessions
      };

    case CoachingSessionActionTypes.UPDATE:
      return {
        ...state,
        data: state.data.map((session) => {
          if (session.id === action.payload.id) {
            session.status = action.payload.status;
          }
          return session;
        })
      };

    default:
      return state;
  }
}
